import { useEffect, useState } from "react";
import { Box, Grow, Modal, Typography } from "@mui/material";
import GiantModal from "../giantModal/GiantModal";
import CollectionModal from "../collectionModal/CollectionModal";

const TABS = [
  { key: "category", label: "Categories" },
  { key: "collection", label: "Collections" },
];

const TabSwitcher = ({ active, onChange }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: ".25vw",
      padding: ".2vw",
      borderRadius: ".35vw",
      background: "#0D0D0D",
    }}
  >
    {TABS.map((tab) => {
      const isActive = tab.key === active;
      return (
        <Box
          key={tab.key}
          onClick={() => onChange(tab.key)}
          sx={{
            padding: ".3vw .9vw",
            borderRadius: ".25vw",
            cursor: "pointer",
            userSelect: "none",
            background: isActive ? "#262626" : "transparent",
            transition: "background 0.15s ease",
          }}
        >
          <Typography
            fontFamily="Karla"
            fontSize=".85vw"
            fontWeight={500}
            lineHeight="1.1vw"
            color={isActive ? "#50C878" : "#8C8C8C"}
          >
            {tab.label}
          </Typography>
        </Box>
      );
    })}
  </Box>
);

const SelectionModal = ({ openModal, handleClose, initialTab = "category" }) => {
  const [tab, setTab] = useState(initialTab);

  useEffect(() => {
    if (openModal) setTab(initialTab);
  }, [openModal, initialTab]);

  const tabSwitcher = <TabSwitcher active={tab} onChange={setTab} />;

  return (
    <Modal
      open={!!openModal}
      onClose={null}
      sx={{ display: "flex", justifyContent: "center" }}
    >
      <Grow in={!!openModal}>
        <Box
          sx={{
            position: "absolute",
            top: "12%",
            width: "96vw",
            height: "84vh",
            outline: "none",
          }}
          marginX="auto"
        >
          <Box sx={{ width: "100%", height: "100%", display: tab === "category" ? "block" : "none" }}>
            <GiantModal
              embedded
              openModal={openModal}
              handleClose={handleClose}
              tabSwitcher={tabSwitcher}
            />
          </Box>
          <Box sx={{ width: "100%", height: "100%", display: tab === "collection" ? "block" : "none" }}>
            <CollectionModal
              embedded
              openModal={openModal}
              handleClose={handleClose}
              tabSwitcher={tabSwitcher}
            />
          </Box>
        </Box>
      </Grow>
    </Modal>
  );
};

export default SelectionModal;
